import Tooltip from 'antd/lib/tooltip';
import React from 'react';
import { useSelector } from 'react-redux';
import { displayTextForUserGroup, displayUserNameLong } from '../../helpers/displayHelpers';
import { RootState } from '../../reducers/reducers';
import { selectReleasePilotForRelease } from '../../selectors/selectors';
import { DefaultUserGroupId, UserGroup } from '../../types';
import { ReleaseComponentProps } from '../../typescriptHelpers';
import { antGrey } from '../styles/globalStyles';
import Text from 'antd/lib/typography/Text';
import { selectOrgUsersWithGroup } from '../../selectors/memoizedSelectors';

interface GroupTooltipProps extends ReleaseComponentProps {
    group: UserGroup;
    showComma: boolean;
    isDisabled: boolean;
}

const GroupTooltip: React.FC<GroupTooltipProps> = (props: GroupTooltipProps) => {
    if (!props.group) {
        return <></>;
    }

    const usersWithGroup = useSelector((state: RootState) => selectOrgUsersWithGroup(state, props.group.id));
    const releasePilot = useSelector((state: RootState) =>
        selectReleasePilotForRelease(state, props.appId, props.releaseId),
    );

    const isPilotGroup = props.group.id === DefaultUserGroupId.Pilot;

    const tooltipText = () => {
        if (isPilotGroup && releasePilot) {
            return `${displayUserNameLong(releasePilot)} is the release pilot`;
        } else if (isPilotGroup && !releasePilot) {
            return `This release has no release pilot`;
        } else if (usersWithGroup.length === 0) {
            return `No users with user group`;
        } else {
            return usersWithGroup
                .map((user) => {
                    return displayUserNameLong(user);
                })
                .join(', ');
        }
    };

    const displayText = (
        <Text style={{ color: props.isDisabled ? antGrey.grey6 : antGrey.grey8 }}>
            {displayTextForUserGroup(props.group)}
            {props.showComma && ', '}
        </Text>
    );
    return (
        <>
            {props.isDisabled ?
                <>{displayText}</>
            :   <Tooltip title={tooltipText()} placement="topRight">
                    <>{displayText}</>
                </Tooltip>
            }
        </>
    );
};

export default GroupTooltip;
